import { render, staticRenderFns } from "./profilelement.vue?vue&type=template&id=cc974214"
import script from "./profilelement.vue?vue&type=script&lang=js"
export * from "./profilelement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports